import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, SearchIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { mainNav } from '../../data/navigation';
import { Logo } from '../brand/Logo';
import { SearchBox } from './SearchBox';
import { MobileMenu } from './MobileMenu';
const ease = [0.23, 1, 0.32, 1] as const;
export function Header() {
  const {
    count,
    open
  } = useCart();
  const {
    pathname
  } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => setSearchOpen(false), [pathname]);
  const overlay = pathname === '/' && !scrolled && !searchOpen;
  const navItems = mainNav.filter(n => n.to !== '/collectie/alles');
  return <>
      <header className={`fixed inset-x-0 top-0 z-40 border-b text-ink transition-[background-color,border-color] duration-200 ${overlay ? 'border-transparent bg-transparent' : 'border-line bg-canvas/90 backdrop-blur-md'}`} data-id="element-206" data-mp="glqccpzb4nkb">
        <div className="mx-auto grid h-16 max-w-7xl grid-cols-[1fr_auto_1fr] items-center px-5 lg:h-[4.5rem] lg:px-8" data-id="element-207" data-mp="3k41id9zz3br9">
          <div className="flex items-center" data-id="element-208" data-mp="3p34nsvjv7jzr">
            <button type="button" onClick={() => setMenuOpen(true)} className="-ml-2 grid h-10 w-10 place-items-center rounded-full lg:hidden" aria-label="Menu openen" data-id="element-209" data-mp="3tzbkdxqdfj51">
              <MenuIcon className="h-5 w-5" data-id="element-210" data-mp="19c8dhlgh0ev3" />
            </button>
            <nav aria-label="Shop" className="hidden lg:block" data-id="element-211" data-mp="1dapinzgbzf9v">
              <ul className="flex items-center gap-7" data-id="element-212" data-mp="3ac4xpj0eaqki">
                {navItems.map(item => <li key={item.to} data-id="element-213" data-mp="35dk5a5rdxb6m">
                    <NavLink to={item.to} className={({
                  isActive
                }) => `whitespace-nowrap text-sm font-medium transition-colors duration-150 ${isActive ? 'text-pink' : 'text-ink/75 hover:text-ink'}`} data-id="element-214" data-mp="35cikh9kkhabp">
                      {item.label}
                    </NavLink>
                  </li>)}
              </ul>
            </nav>
          </div>

          <Link to="/" aria-label="AMIRA Beauty, naar home" data-id="element-215" data-mp="30eqtqivnru93">
            <Logo data-id="element-216" data-mp="30ga9m8dek3ac" />
          </Link>

          <div className="flex items-center justify-end gap-1 sm:gap-2" data-id="element-217" data-mp="2vmyy3txnayc3">
            <Link to="/collectie/alles" className="hidden whitespace-nowrap px-3 text-sm font-medium text-ink/75 transition-colors duration-150 hover:text-ink xl:block" data-id="element-218" data-mp="27xwkcx64tpmv">
              Shop alles
            </Link>
            <button type="button" onClick={() => setSearchOpen(s => !s)} className="grid h-10 w-10 place-items-center rounded-full" aria-label={searchOpen ? 'Zoeken sluiten' : 'Zoeken'} aria-expanded={searchOpen} data-id="element-219" data-mp="ih0ymyhwx3tk">
              {searchOpen ? <XIcon className="h-5 w-5" data-id="element-220" data-mp="eee42ptux4so" /> : <SearchIcon className="h-5 w-5" data-id="element-221" data-mp="efp6ombkg6i7" />}
            </button>
            <button type="button" onClick={open} className="flex h-10 items-center gap-2 rounded-full bg-ink pl-3.5 pr-1.5 text-sm font-medium text-canvas transition-colors duration-150 hover:bg-berry" aria-label={`Winkelwagen, ${count} artikelen`} data-id="element-222" data-mp="124i6itvb6yi3">
              <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-223" data-mp="x4dogzer5vpr" />
              <span className={`grid h-7 min-w-7 place-items-center rounded-full px-1.5 text-xs font-semibold tabular-nums ${count > 0 ? 'bg-pink text-white' : 'bg-canvas text-ink'}`} data-id="element-224" data-mp="3cw9x4je5kni6">
                {count}
              </span>
            </button>
          </div>
        </div>

        <AnimatePresence data-id="element-225" data-mp="3seuhh6vsy1h0">
          {searchOpen && <motion.div initial={{
          opacity: 0,
          y: -6
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -6
        }} transition={{
          duration: 0.18,
          ease
        }} className="border-t border-line bg-canvas" data-id="element-226" data-mp="3sd9mxh9hmij5">
              <div className="mx-auto max-w-2xl px-5 py-4" data-id="element-227" data-mp="jxzoqk8pxxgn">
                <SearchBox autoFocus onNavigate={() => setSearchOpen(false)} data-id="element-228" data-mp="fxfoh7sumdqa" />
              </div>
            </motion.div>}
        </AnimatePresence>
      </header>

      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-229" data-mp="b0flx6v7jt3x" />
    </>;
}